var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var USIncomeConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
export var USIncomeColumn;
(function (USIncomeColumn) {
    USIncomeColumn["Total"] = "Total";
    USIncomeColumn["G10000"] = "<$10,000";
    USIncomeColumn["G10000To14999"] = "$10,000-$14,999";
    USIncomeColumn["G15000To24999"] = "$15,000-$24,999";
    USIncomeColumn["G25000To34999"] = "$25,000-$34,999";
    USIncomeColumn["G35000To49999"] = "$35,000-$49,999";
    USIncomeColumn["G50000To74999"] = "$50,000-$74,999";
    USIncomeColumn["G75000To99999"] = "$75,000-$99,999";
    USIncomeColumn["G100000To149999"] = "$100,000-$149,999";
    USIncomeColumn["G150000To199999"] = "$150,000-$199,999";
    USIncomeColumn["G200000"] = "$200,000+";
    USIncomeColumn["MedianIncome"] = "Median Income";
    USIncomeColumn["MeanIncome"] = "Mean Income";
})(USIncomeColumn || (USIncomeColumn = {}));
const schema = {
    $id: 'urn:wisepipe-common-pipe:USIncomeConfig',
    type: 'object',
    properties: {
        countyColumn: { type: 'string', minLength: 1 },
        stateColumn: { type: 'string', minLength: 1 },
        columns: {
            type: 'array',
            items: { type: 'string', enum: Object.values(USIncomeColumn) },
            minItems: 1,
            uniqueItems: true
        }
    },
    required: ['stateColumn', 'columns']
};
let USIncomeConfig = USIncomeConfig_1 = class USIncomeConfig extends ToolConfig {
    constructor(stateColumn, columns, countyColumn, customFormats) {
        super(ToolType.US_INCOME, customFormats);
        if (countyColumn !== undefined)
            this.countyColumn = countyColumn;
        this.stateColumn = stateColumn;
        this.columns = columns;
        JSON.validate(this, USIncomeConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return USIncomeConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return USIncomeConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return USIncomeConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return USIncomeConfig_1.outs;
    }
    static get in() {
        return USIncomeConfig_1.ins[0];
    }
    static get out() {
        return USIncomeConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo('US Income', [ToolCategories.DATA], this.ins, this.outs, ['demographic', 'earning'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        const exp = tsb.export(this.out);
        if (source) {
            const requiredCols = [this.stateColumn];
            if (this.countyColumn)
                requiredCols.push(this.countyColumn);
            const dependents = this.copyAllInsAndReturnDependents(exp, this.in, source, requiredCols);
            this.columns.forEach((c) => {
                exp.makeNew(new Column(c, 'number'), dependents, true);
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const inputs = new Map([[this.stateColumn, ['string']]]);
        if (this.countyColumn !== undefined) {
            inputs.set(this.countyColumn, ['string']);
        }
        return isSourceValid(source, inputs, this.columns) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
USIncomeConfig = USIncomeConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.US_INCOME)
], USIncomeConfig);
export { USIncomeConfig };
//# sourceMappingURL=usIncomeConfig.js.map